import styled from 'styled-components';

const thBase = styled.th`
  text-align: left;
  padding: 14px 18px;
  vertical-align: middle;
  white-space: nowrap;
`;

export const LocacoesThId = styled(thBase)`
  width: 76px;
`;

export const LocacoesThCodigo = styled(thBase)`
  width: 10%;
  min-width: 96px;
`;

export const LocacoesThEndereco = styled(thBase)`
  width: 40%;
  min-width: 200px;
`;

export const LocacoesThPretendentes = styled(thBase)`
  width: 26%;
  min-width: 160px;
`;

export const LocacoesThData = styled(thBase)`
  width: 184px;
  min-width: 184px;
  box-sizing: border-box;
`;

export const LocacoesThOrigem = styled(thBase)`
  width: 88px;
  min-width: 88px;
  box-sizing: border-box;
`;

const tdBase = styled.td`
  padding: 15px 18px;
  min-height: 52px;
  box-sizing: border-box;
  vertical-align: middle;
  border: none;
  border-bottom: 1px solid #ececec;
  background: #fff;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #3d4f63;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

/** Mesmo padrão do admin colaborador (RequestRow na lista de locações). */
export const LocacoesRow = styled.tr`
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.15s ease;

  &:hover td {
    background-color: ${props => props.theme['table_line-hover']} !important;
  }
`;

export const LocacoesTdId = styled(tdBase)`
  width: 76px;
  max-width: 76px;
  font-weight: 600;
  color: #152b4e;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
`;

export const LocacoesTdCodigo = styled(tdBase)`
  max-width: 0;
  font-family: ui-monospace, 'SF Mono', Consolas, monospace;
  font-size: 0.78rem;
  color: #5c6a7a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LocacoesTdEndereco = styled(tdBase)`
  max-width: 0;
  color: #3d4f63;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LocacoesTdPretendentes = styled(tdBase)`
  max-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LocacoesTdData = styled(tdBase)`
  width: 184px;
  min-width: 184px;
  max-width: 184px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5c6a7a;
  font-size: 0.78rem;
`;

export const LocacoesTdOrigem = styled(tdBase)`
  width: 88px;
  min-width: 88px;
  max-width: 88px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3d4f63;
  font-weight: 600;
`;
